<div class="col-md-12">
    <br/>
    <p-button 
    matTooltip="Export Data"
    matTooltipPosition="above"
     appendTo="body" label="Export to CSV"
     (click)="exportToCSV()"></p-button>  
</div>

<app-quickview-sidebar [columnJSON]="quickviewcols" [selectedData]="selectedRowData" 
[display]="true" (CloseEvent)="QuickViewCloseEvent($event)"></app-quickview-sidebar>
